// client/src/components/RequestOrganiserForm.js
import React, { useState } from 'react';
import { apiFetch } from '../lib/api';

export default function RequestOrganiserForm({ onSubmitted }) {
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');

  const submit = async () => {
    setSending(true);
    setMsg('');
    setErr('');
    try {
      const res = await apiFetch('/api/groups/organiser/request', { method: 'POST' });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || `HTTP ${res.status}`);
      setMsg(data?.message || 'Request submitted. Waiting for superadmin approval.');
      if (typeof onSubmitted === 'function') onSubmitted(data);
    } catch (e) {
      setErr(e.message || 'Failed to submit organiser request.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="card">
      <h3>Request Organiser Approval</h3>
      <p>Ask the superadmin for a one-time approval to create a group.</p>
      <button onClick={submit} disabled={sending}>
        {sending ? 'Submitting…' : 'Request Approval'}
      </button>
      {msg && <p style={{ marginTop: 8 }} className="success">{msg}</p>}
      {err && <p style={{ marginTop: 8 }} className="error">{err}</p>}
    </div>
  );
}
